import { Component, Input, OnInit } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-chip-status',
  imports: [MatChipsModule],
  templateUrl: './chip-status.component.html',
  styleUrls: ['./chip-status.component.css'],
})
export class ChipStatusComponent implements OnInit {
  constructor() {}

  @Input() public status: string;

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
